function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEmex = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 70 70",
    width: 210,
    height: 210,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M4.27,65.74c-5.69-5.69-5.69-14.91,0-20.6l10.14-10.14L4.27,24.86C-1.42,19.18-1.42,9.95,4.27,4.27,7.11,1.42,10.84,0,14.56,0s7.45,1.42,10.3,4.27l10.14,10.14,10.14-10.14c2.84-2.84,6.57-4.27,10.3-4.27s7.45,1.42,10.3,4.27c5.69,5.69,5.69,14.91,0,20.6l-10.14,10.14,10.14,10.14c5.69,5.69,5.69,14.91,0,20.6-2.84,2.84-6.57,4.26-10.3,4.26s-7.45-1.42-10.3-4.26l-10.14-10.14-10.14,10.14c-2.84,2.84-6.57,4.26-10.3,4.26s-7.45-1.42-10.3-4.26",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.67,35c0-4.05,3.28-7.33,7.33-7.33s7.32,3.28,7.32,7.33-3.28,7.32-7.32,7.32-7.33-3.28-7.33-7.32m17.97,10l9.95-10-10.42-10.47c-5.63-5.63-14.75-5.63-20.38,0l-10.39,10.47,9.92,10c5.89,5.89,15.44,5.89,21.33,0",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4,35l10.39-10.47c5.63-5.63,14.75-5.63,20.37,0l10.42,10.47-9.95,10c-5.89,5.89-15.44,5.89-21.33,0l-9.92-10Zm20.6,20.6l10.14,10.14c2.84,2.84,6.57,4.26,10.3,4.26s7.45-1.42,10.3-4.26c5.69-5.69,5.69-14.91,0-20.6l-10.14-10.14,10.14-10.14c5.69-5.69,5.69-14.91,0-20.6C62.89,1.42,59.16,0,55.44,0s-7.45,1.42-10.3,4.27l-10.14,10.14L24.86,4.27C22.02,1.42,18.29,0,14.56,0S7.11,1.42,4.27,4.27c-5.69,5.69-5.69,14.91,0,20.6l10.14,10.14-10.14,10.14c-5.69,5.69-5.69,14.91,0,20.6,2.85,2.84,6.57,4.26,10.3,4.26s7.45-1.42,10.3-4.26l10.14-10.14Z",
    style: {
      fill: "#99cbc3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.33,35c0-4.05-3.28-7.33-7.32-7.33s-7.33,3.28-7.33,7.33,3.28,7.32,7.33,7.32,7.32-3.28,7.32-7.32",
    style: {
      fill: "#d25425"
    }
  }));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEmex);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/emex.228d605fb036647ab406c3683588d2b5.svg";